export default {
  auth: {
    login: '',
    password: '',
    loading: false,
  },
  settings: null,
};
